import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"

export const FooterMenu = () => {
  return (
    <div>
      <StaticQuery
        query={graphql`
          query {
            prismicGlobals {
              data {
                footer_email {
                  text
                }
                privacy_policy {
                  url
                }
                terms___conditions {
                  url
                }
                partners {
                  url
                }
              }
            }
          }
        `}
        render={(data) => (
          <div>
            <ul>
              <li>
                <Link to={data?.prismicGlobals?.data?.terms___conditions?.url}>
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link to={data?.prismicGlobals?.data?.privacy_policy?.url}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={`/partners`}>Partner Resources</Link>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`mailto:hello@mytrev.com`}
                >
                  hello@mytrev.com
                </a>
              </li>
            </ul>
          </div>
        )}
      />
    </div>
  )
}
